//base
import React, { useCallback, useEffect, useMemo, useState } from 'react';
//style
import { StyledBasicSelect } from './style';
import { themeOptions } from 'styles';

import { commonImage, arrowImage } from 'constants/images';

//libraries
import { InputAdornment } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export const BasicSelectV2 = ({
  name,
  width,
  label,
  labelName,
  valueName,
  options,
  required,
  sendValue,
  value,
  className,
  onSelected,
  placeholder = 'Select',
  marginBottom,
  disabled,
  isUsePadding = true,
  ...props
}) => {
  const [selectedOption, setSelectedOption] = useState();

  const selectOptions = useMemo(() => {
    const result = options.map((item) => ({
      label: labelName,
      value: valueName,
      ...item
    }));

    setSelectedOption(value);

    return result;
  }, [labelName, options, valueName, value]);

  const handleChange = (e, child) => {
    setSelectedOption(e.target.value);

    if (onSelected) {
      onSelected(child.props);
    }

    if (!sendValue) return;

    sendValue(e, child);
    handleSelectOpen(false);
  };

  useEffect(() => {
    if (!value) return;

    setSelectedOption(value);
  }, [value]);

  const [selectOpen, setSelectOpen] = useState(false);

  const handleSelectOpen = (isOpen) => {
    setSelectOpen(isOpen);
  };

  return (
    <StyledBasicSelect
      width={width}
      marginbottom={marginBottom}
      className={className}
      isusepadding={isUsePadding ? 'true' : ''}
    >
      {label && (
        <span className="bs-label">
          {label}
          {required && <span className="required">*</span>}
        </span>
      )}
      <Select
        name={name}
        label={label}
        disabled={disabled}
        open={selectOpen}
        onOpen={() => handleSelectOpen(true)}
        onClose={() => handleSelectOpen(false)}
        value={selectedOption}
        onChange={handleChange}
        IconComponent={() =>
          name === 'language' ? (
            <img src={commonImage.laguage} alt="language" />
          ) : (
            <img
              src={arrowImage.arrowTriangle}
              alt="arrow"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (disabled) return;

                handleSelectOpen(true);
              }}
            />
          )
        }
        MenuProps={menuProps}
        {...props}
      >
        {selectOptions.map(({ label, value }, i) => {
          return (
            <MenuItem key={i} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </StyledBasicSelect>
  );
};

const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: `${themeOptions.palette.white.main}`,
      padding: '5px',
      margin: '8px 0 0 0',
      borderRadius: '6px',
      border: '1px solid #dadada',
      boxShadow: '0px 4px 10px 0px #0000001A',
      boxSizing: 'border-box',
      '& .MuiMenuItem-root': {
        height: '40px',
        '&:hover': {
          bgcolor: `${themeOptions.palette.green.main} !important`,
          color: `${themeOptions.palette.white.main}`,
          borderRadius: '4px'
        }
      },
      '& .MuiList-root': {
        padding: 0
      },
      '& .Mui-selected': {
        bgcolor: `${themeOptions.palette.green.main} !important`,
        borderRadius: '4px',
        color: `${themeOptions.palette.white.main}`
      }
    }
  }
};
